module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents exclude-auto page-open-auto",
    attrs: {
      "id": "TableOfContents1"
    }
  }, [_c('div', {
    staticClass: "title-block exclude-auto",
    attrs: {
      "id": "title-block3"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h14"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }), _c('div', {
    staticClass: "named-lists toc-lists exclude-auto",
    attrs: {
      "id": "toc-lists1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }), _c('div', {
    staticClass: "list-named list-toc exclude-auto",
    attrs: {
      "id": "list-toc1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }), _c('ol', {
    attrs: {
      "id": "ol1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }), _c('li', {
    staticClass: "toc-fm",
    attrs: {
      "id": "toc-fm1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_vii"
    }
  }, [_c('i')]), _c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_booktitlepage#BookTitlePage1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-fm",
    attrs: {
      "id": "toc-fm2"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_dedication#Dedication1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-fm",
    attrs: {
      "id": "toc-fm3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_listofillustrations#ListOfIllustrations1"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])]), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "toc-fm",
    attrs: {
      "id": "toc-fm4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_prologue#Prologue1"
    }
  }, [_vm._v("Prologue ")]), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_chapter_02#Chapter2"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("1")]), _vm._v(" Dentdale Gloves ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_04#Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("2")]), _vm._v(" Proper Ganseys ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_06#Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("3")]), _vm._v(" Revolutionary Knitting ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_08#Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("4")]), _vm._v(" Highland Kilts and Stockings ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_10#Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("5")]), _vm._v(" A Not-So-Itsy-Bitsy Bikini ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_12#Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("6")]), _vm._v(" Carding, Combing and Cricket ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_14#Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("7")]), _vm._v(" Vikings, Socks and the Great Yorkshire Llama ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_16#Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("8")]), _vm._v(" Knit-frocks, Guernseys and Jerseys ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_18#Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("9")]), _vm._v(" Shetland Stitches ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_20#Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("10")]), _vm._v(" Monmouth Caps and Funeral Stockings ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_22#Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("11")]), _vm._v(" Haps, Shawls and New Arrivals ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_24#Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_vm._v("12")]), _vm._v(" A Time of Gifts ")]), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm1"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_bibliography#Bibliography1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography ")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm2"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_acknowledgements#Acknowledgements1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements ")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm3"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_other_03#Other3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Notes and Credits ")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm7"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_other_04#Other4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text Permissions")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm4"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_index_01_a#Index1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index ")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm6"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#PlatePage1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-bm",
    attrs: {
      "id": "toc-bm5"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/9781783784370_copyrightinserted#CopyrightInserted1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fcc09c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781783784370_tableofcontents.vue
// module id = 69
// module chunks = 0